(() => {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const KIDDOSCOPE_URL = '/products/kiddoscope-microscope-de-poche-pour-enfants';
  const PACKS_URL = '/pages/packs';

  const PRODUCT_HANDLES = {
    kiddoscope: 'kiddoscope-microscope-de-poche-pour-enfants',
    carnet: 'carnet-mystere-du-petit-scientifique',
    lames: 'kit-de-lames-dechantillons',
    adaptateur: 'adaptateur-smartphone',
    complet: 'kit-decouvreur-complet-kiddoscope',
    duo: 'pack-duo-kiddoscope',
    famille: 'pack-famille-kiddoscope'
  };

  const PACK_VARIANTS = {
    kiddoscope: '62613998731345',
    duo: '62724861821009',
    famille: '62724862443601',
    complet: '62616560861265'
  };

  const PACKS = {
    '1': { name:'Pack Découverte', items:[['kiddoscope',1]] },
    '2': { name:'Pack Duo', items:[['duo',1]] },
    '3': { name:'Pack Famille', items:[['famille',1]] },
    kit: { name:'Kit Découvreur Complet', items:[['complet',1]] }
  };

  const normalize = (value) => (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim();

  const setCartBubble = (cart) => {
    const count = Number(cart?.item_count || 0);
    document.querySelectorAll('.cart-count-bubble [aria-hidden="true"]').forEach(el => el.textContent = count);
    document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(el => el.textContent = count + (count > 1 ? ' articles' : ' article'));
  };

  const fetchVariant = async (handle) => {
    const key = Object.keys(PRODUCT_HANDLES).find(k => PRODUCT_HANDLES[k] === handle);
    if (key && PACK_VARIANTS[key]) return PACK_VARIANTS[key];
    const r = await fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', {headers:{Accept:'application/json'}});
    if (!r.ok) throw new Error('Produit introuvable: ' + handle);
    const p = await r.json();
    const v = (p.variants || []).find(x => x.available) || (p.variants || [])[0];
    if (!v?.id || v.available === false) throw new Error('Produit indisponible: ' + handle);
    return v.id;
  };

  const addItems = async (items) => {
    const resolved = [];
    for (const [key, quantity] of items) resolved.push({id: await fetchVariant(PRODUCT_HANDLES[key]), quantity});
    const r = await fetch(ROOT + 'cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:resolved})
    });
    if (!r.ok) {
      const err = await r.json().catch(()=>({}));
      throw new Error(err.description || 'Ajout impossible');
    }
    const cart = await fetch(ROOT + 'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
    setCartBubble(cart);
    return cart;
  };

  const setPackAttribute = async (key) => {
    await fetch(ROOT + 'cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({attributes:{kiddoscope_pack:key}})
    });
  };

  // ---------------------------------------------------------------------------
  // [V2] Détection du pack, indépendante du markup des cartes.
  // On s'appuie sur ce que la page affiche : le nom des packs dans le texte des
  // cartes, et l'état « sélectionné » (classe, aria, radio coché).
  // ---------------------------------------------------------------------------
  const PACK_NAMES = [['1','pack decouverte'], ['2','pack duo'], ['3','pack famille']];
  const SKIP_TAGS = /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE|SVG|PATH)$/i;
  const SELECTED_RE = /(^|[\s_-])(selected|active|checked|chosen|current)($|[\s_-])/i;
  const SELECTED_ATTR = '[aria-checked="true"],[aria-pressed="true"],[aria-selected="true"],[data-selected="true"],[data-state="checked"],[data-state="active"]';
  const SELECTED_DESC = SELECTED_ATTR + ',input:checked,.is-selected,.selected,.active,.is-active,.checked';
  const ACCESSORY_SEL = '[data-product-handle],.kiddoscope-accessory-card,.product-card,.product-item';

  // Cartes de packs : pour chaque nom de pack, le plus petit élément qui le
  // contient, agrandi tant que le parent ne mentionne pas un autre pack.
  const findPackCards = () => {
    const els = [...document.body.querySelectorAll('*')].filter(el => !SKIP_TAGS.test(el.tagName));
    const text = new Map(els.map(el => [el, normalize(el.textContent)]));
    const found = [];
    PACK_NAMES.forEach(([key, name]) => {
      els.forEach(el => {
        if (!text.get(el).includes(name)) return;
        if ([...el.children].some(c => text.get(c)?.includes(name))) return;
        let card = el;
        while (card.parentElement && card.parentElement !== document.body) {
          const t = text.get(card.parentElement) || '';
          if (PACK_NAMES.some(([k, n]) => k !== key && t.includes(n))) break;
          card = card.parentElement;
        }
        found.push({key, card});
      });
    });
    return found;
  };

  // Une vraie carte a des « jumelles » (même balise, même 1re classe) pour les autres packs.
  const hasTwin = (item, all) => all.some(o =>
    o.key !== item.key &&
    o.card.tagName === item.card.tagName &&
    (o.card.classList[0] || '') === (item.card.classList[0] || '')
  );

  const isSelectedCard = (card) => {
    if (card.matches?.(SELECTED_ATTR) || SELECTED_RE.test(String(card.className))) return true;
    if (card.querySelector?.(SELECTED_DESC)) return true;
    const forId = card.getAttribute?.('for');
    if (forId && document.getElementById(forId)?.checked) return true;
    const prev = card.previousElementSibling;
    if (prev && prev.matches?.('input:checked')) return true;
    return false;
  };

  const getSelectedDataPack = () => {
    const selected = document.querySelector(
      '[data-pack].is-selected, [data-pack][aria-checked="true"], [data-pack].selected, [data-pack].active, input[data-pack]:checked'
    );
    const key = selected?.dataset.pack || null;
    return key && PACKS[key] ? key : null;
  };

  // Renvoie la clé du pack ('1' | '2' | '3' | 'kit') ou null si indéterminé.
  const resolvePack = (btn, allowSelection = true) => {
    // 1) carte balisée data-pack contenant le bouton
    const direct = btn?.closest?.('[data-pack]');
    if (direct && PACKS[direct.dataset.pack]) return direct.dataset.pack;

    const cards = findPackCards();
    const real = cards.filter(c => hasTwin(c, cards));

    // 2) bouton situé à l'intérieur d'une carte de pack (la plus interne)
    if (btn) {
      const inside = real.filter(c => c.card.contains(btn));
      if (inside.length) {
        inside.sort((a, b) => a.card.textContent.length - b.card.textContent.length);
        return inside[0].key;
      }
    }

    // 3) bouton partagé : pack sélectionné (sauf bouton d'un accessoire)
    if (allowSelection) {
      const dataSel = getSelectedDataPack();
      if (dataSel) return dataSel;
      const selected = new Set(real.filter(c => isSelectedCard(c.card)).map(c => c.key));
      if (selected.size === 1) return [...selected][0];
    }

    if (real.length) console.warn('[Kiddoscope] pack non déterminé', real.map(c => c.key));
    return null;
  };

  const isPacksContext = () =>
    location.pathname.startsWith(PACKS_URL) ||
    !!document.querySelector('[data-pack], [data-kiddoscope-bundles]') ||
    new Set(findPackCards().map(c => c.key)).size >= 2;

  const updatePackLabel = (key) => {
    const label = document.querySelector('[data-kiddoscope-pack-label]');
    if (label && PACKS[key]) label.textContent = PACKS[key].name + ' sélectionné · clique sur « Ajouter au panier ».';
  };

  const selectPack = (key) => {
    if (!PACKS[key]) return;
    const root = document.querySelector('[data-kiddoscope-bundles]');
    document.querySelectorAll('[data-pack]').forEach(card => {
      const on = card.dataset.pack === key;
      card.classList.toggle('is-selected',on);
      card.setAttribute('aria-checked',on ? 'true':'false');
    });
    updatePackLabel(key);
    root?.scrollIntoView({behavior:'smooth',block:'center'});
  };

  const bundleAdd = async (key, button) => {
    const pack = PACKS[key];
    if (!pack) return;
    if (button.dataset.kpBusy === 'true') return;
    button.dataset.kpBusy='true';
    button.disabled=true;
    const original=button.textContent;
    button.textContent='Ajout du pack…';
    try {
      await addItems(pack.items);
      await setPackAttribute(key);
      button.textContent='Pack ajouté ✓';
      setTimeout(()=>{button.textContent=original;button.disabled=false;button.dataset.kpBusy='false';},1800);
    } catch(e) {
      console.error('[Kiddoscope] bundle:',e);
      alert('Impossible d’ajouter ce pack au panier. Vérifie que tous ses produits sont publiés et disponibles.');
      button.textContent=original;button.disabled=false;button.dataset.kpBusy='false';
    }
  };

  const rewriteLinks = (root=document) => {
    root.querySelectorAll?.('a,button').forEach(el => {
      const text=normalize(el.textContent);
      if (!text) return;
      if (text==='decouvrir le kiddoscope' || text==='voir les offres' || text==='commander maintenant') {
        if (el.tagName==='A') el.href=KIDDOSCOPE_URL;
        el.dataset.kiddoscopeDestination=KIDDOSCOPE_URL;
      }
      if (text==='commander mon kiddoscope') {
        if (el.tagName==='A') el.href=PACKS_URL;
        el.dataset.kiddoscopeDestination=PACKS_URL;
      }
      if (text.includes('ajouter au panier') && el.tagName==='A' && /kiddoscope\.netlify\.app/i.test(el.getAttribute('href')||'')) {
        el.href='#'; el.dataset.kiddoscopeCartButton='true';
      }
    });
  };

  document.addEventListener('click', async event => {
    const btn=event.target.closest('[data-bundle-add]');
    if(btn){
      event.preventDefault(); event.stopPropagation();
      const key=resolvePack(btn);
      if(key) await bundleAdd(key,btn);
      return;
    }
  }, true);

  document.addEventListener('click', async (event) => {
    const clickable=event.target.closest('a,button');
    if (!clickable) return;

    const selectKey=clickable.dataset.selectKiddoscopePack;
    if (selectKey && PACKS[selectKey]) {
      event.preventDefault(); event.stopPropagation();
      selectPack(selectKey);
      return;
    }

    const text=normalize(clickable.textContent);
    if (text==='decouvrir le kiddoscope' || text==='voir les offres' || text==='commander maintenant') {
      event.preventDefault(); event.stopPropagation(); window.location.href=KIDDOSCOPE_URL; return;
    }
    if (text==='commander mon kiddoscope') {
      event.preventDefault(); event.stopPropagation(); window.location.href=PACKS_URL; return;
    }

    if (!text.includes('ajouter au panier')) return;

    const nativeForm=clickable.closest('form');

    // [V2] Pack déterminé depuis la carte cliquée, sinon depuis la sélection
    const isAccessory = !!clickable.closest(ACCESSORY_SEL);
    const packKey = resolvePack(clickable, !isAccessory);

    if (packKey) {
      event.preventDefault(); event.stopPropagation();
      await bundleAdd(packKey, clickable);
      return;
    }

    if (clickable.tagName==='BUTTON' && nativeForm && (nativeForm.dataset.type==='add-to-cart-form' || /\/cart\/add(?:\.js)?/.test(nativeForm.getAttribute('action')||''))) return;

    event.preventDefault(); event.stopPropagation();
    const handle = (() => {
      const explicit=clickable.dataset.productHandle || clickable.dataset.handle;
      if (explicit) return explicit;
      const href=clickable.getAttribute('href')||'';
      const m=href.match(/^\/products\/([^/?#]+)/);
      if (m) return decodeURIComponent(m[1]);
      const c=clickable.closest('[data-product-handle],article,.card,.product-card,.product-item,.grid__item,.kiddoscope-product-card,.kiddoscope-accessory-card,li')||clickable.parentElement;
      const t=normalize(c?.textContent);
      if(t.includes('kit decouvreur complet')) return PRODUCT_HANDLES.complet;
      if(t.includes('adaptateur smartphone')) return PRODUCT_HANDLES.adaptateur;
      if(t.includes('kit de lames')) return PRODUCT_HANDLES.lames;
      if(t.includes('carnet mystere') || t.includes('carnet du petit scientifique')) return PRODUCT_HANDLES.carnet;
      // [V2] Sur une page de packs, on n'ajoute jamais un produit au hasard
      if (isPacksContext()) return null;
      return PRODUCT_HANDLES.kiddoscope;
    })();

    if (!handle) {
      alert('Choisis d’abord un pack en cliquant sur sa carte, puis clique sur « Ajouter au panier ».');
      return;
    }

    try {
      clickable.disabled=true;
      const original=clickable.textContent;
      clickable.textContent='Ajout…';
      await addItems([[Object.keys(PRODUCT_HANDLES).find(k=>PRODUCT_HANDLES[k]===handle)||'kiddoscope',1]]);
      clickable.textContent='Ajouté au panier ✓';
      setTimeout(()=>{clickable.textContent=original;clickable.disabled=false;},1600);
    } catch(e) {
      clickable.disabled=false;
      alert('Impossible d’ajouter ce produit au panier pour le moment.');
    }
  }, true);

  // Sélection d'une carte balisée data-pack
  document.addEventListener('click', event => {
    const card=event.target.closest('[data-pack]');
    if (card && PACKS[card.dataset.pack]) selectPack(card.dataset.pack);
  }, true);

  document.addEventListener('submit', async event => {
    const form=event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add(?:\.js)?/.test(form.getAttribute('action')||'')) return;
    const button=form.querySelector('[type="submit"]');
    const key = resolvePack(button || form, !form.closest(ACCESSORY_SEL));
    if (!key) return;
    event.preventDefault();
    event.stopPropagation();
    await bundleAdd(key, button || document.body);
  }, true);

  // Cart pack normalization.
  // Pricing ladder: 1 Discovery = 29,90 €; 2 = Duo 49,90 €; 3 = Family 69,90 €.
  const normalizeCartPacks = async () => {
    if (!location.pathname.includes('/cart') || window.__kiddoscopePackNormalizing) return;
    window.__kiddoscopePackNormalizing = true;
    try {
      const cart = await fetch(ROOT + 'cart.js', {headers:{Accept:'application/json'}}).then(response => {
        if (!response.ok) throw new Error('cart-read');
        return response.json();
      });
      const hasDiscovery = (cart.items || []).some(item => String(item.variant_id) === String(PACK_VARIANTS.kiddoscope));
      if (hasDiscovery && cart.attributes?.kiddoscope_pack !== '1') await setPackAttribute('1');
    } catch (error) {
      console.error('[Kiddoscope] cart attribute update:', error);
    } finally {
      window.__kiddoscopePackNormalizing = false;
    }
  };

  let cartPackNormalizationTimer;
  const scheduleCartPackNormalization = () => {
    clearTimeout(cartPackNormalizationTimer);
    cartPackNormalizationTimer = setTimeout(normalizeCartPacks, 900);
  };

  // Shopify's cart component updates the cart asynchronously. Listen for the
  // actual cart request as well as the visible +/- controls.
  if (!window.__kiddoscopeFetchHookInstalled) {
    window.__kiddoscopeFetchHookInstalled = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = async function() {
      const input = arguments[0];
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const result = await originalFetch.apply(window, arguments);
      if (
        location.pathname.includes('/cart') &&
        !window.__kiddoscopePackNormalizing &&
        /\/cart\/(change|update|add)(\.js)?(?:[?#]|$)/.test(url)
      ) {
        setTimeout(normalizeCartPacks, 350);
      }
      return result;
    };
  }

  document.addEventListener('click', event => {
    if (!location.pathname.includes('/cart')) return;
    const target = event.target.closest('button,a,input');
    if (!target) return;
    const text = normalize(target.textContent);
    const name = (target.getAttribute('name') || '').toLowerCase();
    const cls = String(target.className || '').toLowerCase();
    const isQuantityControl =
      /^(plus|minus)$/.test(name) ||
      text === '+' || text === '-' ||
      /quantity|increment|decrement/.test(cls) ||
      !!target.closest('quantity-input,cart-quantity,cart-items-component,[data-cart-quantity]');
    if (isQuantityControl) scheduleCartPackNormalization();
  }, true);

  document.addEventListener('change', event => {
    if (!location.pathname.includes('/cart')) return;
    if (event.target.matches('input[name="updates[]"], input[type="number"], [data-quantity-input]')) {
      scheduleCartPackNormalization();
    }
  }, true);

  document.addEventListener('cart:updated', scheduleCartPackNormalization);

  if (location.pathname.includes('/cart')) {
    setTimeout(normalizeCartPacks, 800);
  }

  const init=()=>rewriteLinks(document);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  new MutationObserver(ms=>ms.forEach(m=>m.addedNodes.forEach(n=>{if(n.nodeType===1) rewriteLinks(n)}))).observe(document.documentElement,{childList:true,subtree:true});

  window.KiddoscopeBundles={select:selectPack};
})();